import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssignService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // 👉 Assign project to a user
  assignProject(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/assign_project`, payload);
  }

    updateAssignedProject(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/edit_assign_project`, payload);
  }

  // 👉 Fetch all roles (accounts)
  fetchRoles(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/role_dropdown`,);
  }

  // 👉 Fetch all projects (accounts)
  fetchProjects(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/assign_project_dropdown`, payload);
  }

  // 👉 Fetch assigned projects dropdown for builders and residents
  fetchAssignedProjectsDropdown(user_id: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/assign_project_dropdown`, { user_id });
  }

  // 👉 Fetch assigned units dropdown
  fetchAssignedUnitsDropdown(account_id: number, user_id: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/assign_unit_dropdown`, { account_id, user_id });
  }

  // 👉 Fetch all users
  fetchUsers(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/user_dropdown`, payload);
  }

  // 👉 Fetch assigned projects list
  fetchAssignedProjects(payload: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/fetch_assign_users`, payload);
  }

  // 👉 Delete an assigned project
  deleteAssignedProject(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/delete_assigned_project`, payload);
  }
}
